
import { mapMutations, mapState } from 'vuex'
export default {
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(['publicPath'])
  },
  layout: 'error',
  created() {
    this.setError(true)
  },
  methods: {
    ...mapMutations(['setError'])
  }
}
